import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useToast = () => {
  const showToast = (message, type) => {
    if(type === 'error') toast.error(message);
    if(type === 'success') toast.success(message);
    if(type === 'info') toast.info(message);
    if(type === 'warn') toast.warn(message);
    if(type === 'dark') toast.dark(message);
    if(type === 'default' || type === null ) toast(message);
  };

  return { showToast };
};

export default useToast;